export enum LogoSize {
    CUSTOM = 'custom',
    SM = 'sm',
    MD = 'md',
    LG = 'lg'
}
